import {
  GET_PERSON_EXECUTIONS_REQUEST,
  GET_PERSON_EXECUTIONS_REQUEST_FAILED,
  GET_PERSON_EXECUTIONS_REQUEST_SUCCEEDED
} from "../constants/executions";

export const executions = (
  state = {
    isFetching: false,
    data: [],
    error: {}
  }, action) => {
  let newState = {...state};

  switch (action.type) {
    case GET_PERSON_EXECUTIONS_REQUEST:
      newState.isFetching = true;
      return newState;

    case GET_PERSON_EXECUTIONS_REQUEST_SUCCEEDED:
      newState.isFetching = false;
      newState.data = action.data;
      newState.error = {};
      return newState;

    case GET_PERSON_EXECUTIONS_REQUEST_FAILED:
      newState.isFetching = false;
      newState.error = action.error;
      newState.data = [];
      return newState;

    default:
      return newState;
  }
};
